import { Pipe, PipeTransform } from '@angular/core';
import { SkillConfigurationRemoteDto } from '../../../generated/signalR/skill-configuration-remote-dto';
import { Observable } from 'rxjs';
import { Store } from '@ngxs/store';
import { SamwinSkillsState } from '../../store/samwin/samwin-skills/samwin-skills.state';
import { distinctUntilChanged, map } from 'rxjs/operators';
import _ from 'lodash';

@Pipe({
   name: 'skillIdToShortSkillInfo$',
})
export class SkillIdToShortSkillInfoPipe implements PipeTransform {
   constructor(private store: Store) {}

   transform(skillId: number): Observable<SkillConfigurationRemoteDto> {
      return this.store.select(SamwinSkillsState.getSkillConfigurationFn).pipe(
         map((fn) => fn(skillId)),
         distinctUntilChanged((prev, curr) => _.isEqual(prev, curr))
      );
   }
}
